module.exports = {
  USD: {
    symbol: '$',
    name: 'Yhdysvaltain dollari',
    code: 'USD',
  },
  CAD: {
    symbol: 'CA$',
    name: 'Canadian Dollar',
    code: 'CAD',
  },
  EUR: {
    symbol: '€',
    name: 'Euroopan Euro',
    code: 'EUR',
  },
  AED: {
    symbol: 'AED',
    name: 'Yhdistyneiden Arabiemiraattien dirhami',
    code: 'AED',
  },
  AFN: {
    symbol: 'Af',
    name: 'Afghanistanin Afghani',
    code: 'AFN',
  },
  ALL: {
    symbol: 'ALL',
    name: 'Albanian Lek',
    code: 'ALL',
  },
  AMD: {
    symbol: 'AMD',
    name: 'Armenian Dram',
    code: 'AMD',
  },
  ARS: {
    symbol: 'AR$',
    name: 'Argentiinan peso',
    code: 'ARS',
  },
  AUD: {
    symbol: 'AU$',
    name: 'Australian Dollari',
    code: 'AUD',
  },
  AZN: {
    symbol: 'man.',
    name: 'Azerbaidžanin manat',
    code: 'AZN',
  },
  BAM: {
    symbol: 'KM',
    name: 'Bosnian ja Hertsegovinan vaihdettava markka',
    code: 'BAM',
  },
  BDT: {
    symbol: 'Tk',
    name: 'Bangladeshin Taka',
    code: 'BDT',
  },
  BGN: {
    symbol: 'BGN',
    name: 'Bulgarian Lev',
    code: 'BGN',
  },
  BHD: {
    symbol: 'BD',
    name: 'Bahrainin dinaari',
    code: 'BHD',
  },
  BIF: {
    symbol: 'FBu',
    name: 'Burundin frangi',
    code: 'BIF',
  },
  BND: {
    symbol: 'BN$',
    name: 'Brunein dollari',
    code: 'BND',
  },
  BOB: {
    symbol: 'Bs',
    name: 'Bolivian Boliviano',
    code: 'BOB',
  },
  BRL: {
    symbol: 'R$',
    name: 'Brasilian real',
    code: 'BRL',
  },
  BWP: {
    symbol: 'BWP',
    name: 'Botswanan Pula',
    code: 'BWP',
  },
  BYR: {
    symbol: 'BYR',
    name: 'Valko-Venäjän rupla',
    code: 'BYR',
  },
  BZD: {
    symbol: 'BZ$',
    name: 'Belizen dollari',
    code: 'BZD',
  },
  CDF: {
    symbol: 'CDF',
    name: 'Kongon frangi',
    code: 'CDF',
  },
  CHF: {
    symbol: 'CHF',
    name: 'Sveitsin frangi',
    code: 'CHF',
  },
  CLP: {
    symbol: 'CL$',
    name: 'Chilen peso',
    code: 'CLP',
  },
  CNY: {
    symbol: 'CN¥',
    name: 'Kiinan juan',
    code: 'CNY',
  },
  COP: {
    symbol: 'CO$',
    name: 'Kolumbian peso',
    code: 'COP',
  },
  CRC: {
    symbol: '₡',
    name: 'Costa Rican Colón',
    code: 'CRC',
  },
  CVE: {
    symbol: 'CV$',
    name: 'Kap Verden escudo',
    code: 'CVE',
  },
  CZK: {
    symbol: 'Kč',
    name: 'Tšekin koruna',
    code: 'CZK',
  },
  DJF: {
    symbol: 'Fdj',
    name: 'Djiboutin frangi',
    code: 'DJF',
  },
  DKK: {
    symbol: 'Dkr',
    name: 'Tanskan kruunu',
    code: 'DKK',
  },
  DOP: {
    symbol: 'RD$',
    name: 'Dominikaanisen tasavallan peso',
    code: 'DOP',
  },
  DZD: {
    symbol: 'DA',
    name: 'Algerian dinaari',
    code: 'DZD',
  },
  //   EEK: {
  //     symbol: 'Ekr',
  //     name: 'Estonian Kroon',
  //     code: 'EEK',
  //   },
  EGP: {
    symbol: 'EGP',
    name: 'Egyptin punta',
    code: 'EGP',
  },
  ERN: {
    symbol: 'Nfk',
    name: 'Eritrean Nakfa',
    code: 'ERN',
  },
  ETB: {
    symbol: 'Br',
    name: 'Etiopian Birr',
    code: 'ETB',
  },
  GBP: {
    symbol: '£',
    name: 'Englannin Punta',
    code: 'GBP',
  },
  GEL: {
    symbol: 'GEL',
    name: 'Georgian Lari',
    code: 'GEL',
  },
  GHS: {
    symbol: 'GH₵',
    name: 'Ghanaian Cedi',
    code: 'GHS',
  },
  GNF: {
    symbol: 'FG',
    name: 'Guinean frangi',
    code: 'GNF',
  },
  GTQ: {
    symbol: 'GTQ',
    name: 'Guatemalan Quetzal',
    code: 'GTQ',
  },
  HKD: {
    symbol: 'HK$',
    name: 'Hongkongin dollari',
    code: 'HKD',
  },
  HNL: {
    symbol: 'HNL',
    name: 'Hondurasin lempira',
    code: 'HNL',
  },
  HRK: {
    symbol: 'kn',
    name: 'Kroatian kuna',
    code: 'HRK',
  },
  HUF: {
    symbol: 'Ft',
    name: 'Unkarin forintti',
    code: 'HUF',
  },
  IDR: {
    symbol: 'Rp',
    name: 'Indonesian Rupia',
    code: 'IDR',
  },
  ILS: {
    symbol: '₪',
    name: 'Uusi Israelin sekeli',
    code: 'ILS',
  },
  INR: {
    symbol: 'Rs',
    name: 'Intian rupia',
    code: 'INR',
  },
  IQD: {
    symbol: 'IQD',
    name: 'Irakin dinaari',
    code: 'IQD',
  },
  IRR: {
    symbol: 'IRR',
    name: 'Iranin rial',
    code: 'IRR',
  },
  ISK: {
    symbol: 'Ikr',
    name: 'Islannin kruunu',
    code: 'ISK',
  },
  JMD: {
    symbol: 'J$',
    name: 'Jamaikan dollari',
    code: 'JMD',
  },
  JOD: {
    symbol: 'JD',
    name: 'Jordanian Dinaari',
    code: 'JOD',
  },
  JPY: {
    symbol: '¥',
    name: 'Japanin jeni',
    code: 'JPY',
  },
  KES: {
    symbol: 'Ksh',
    name: 'Kenian šillinki',
    code: 'KES',
  },
  KHR: {
    symbol: 'KHR',
    name: 'Kambodžan riel',
    code: 'KHR',
  },
  KMF: {
    symbol: 'CF',
    name: 'Komorien frangi',
    code: 'KMF',
  },
  KRW: {
    symbol: '₩',
    name: 'Etelä-Korean won',
    code: 'KRW',
  },
  KWD: {
    symbol: 'KD',
    name: 'Kuwaitin dinaari',
    code: 'KWD',
  },
  KZT: {
    symbol: 'KZT',
    name: 'Kazakstanin tenge',
    code: 'KZT',
  },
  LBP: {
    symbol: 'LB£',
    name: 'Libanonin punta',
    code: 'LBP',
  },
  LKR: {
    symbol: 'SLRs',
    name: 'Sri Lankan rupia',
    code: 'LKR',
  },
  LTL: {
    symbol: 'Lt',
    name: 'Lithuanian Litas',
    code: 'LTL',
  },
  LVL: {
    symbol: 'Ls',
    name: 'Latvian Lats',
    code: 'LVL',
  },
  LYD: {
    symbol: 'LD',
    name: 'Libyan Dinaari',
    code: 'LYD',
  },
  MAD: {
    symbol: 'MAD',
    name: 'Marokon dirham',
    code: 'MAD',
  },
  MDL: {
    symbol: 'MDL',
    name: 'Moldovan Leu',
    code: 'MDL',
  },
  MGA: {
    symbol: 'MGA',
    name: 'Madagaskarin Ariary',
    code: 'MGA',
  },
  MKD: {
    symbol: 'MKD',
    name: 'Makedonian Denaari',
    code: 'MKD',
  },
  MMK: {
    symbol: 'MMK',
    name: '	Myanmarin kyat',
    code: 'MMK',
  },
  MOP: {
    symbol: 'MOP$',
    name: 'Macaon pataca',
    code: 'MOP',
  },
  MUR: {
    symbol: 'MURs',
    name: 'Mauritiuksen rupia',
    code: 'MUR',
  },
  MXN: {
    symbol: 'MX$',
    name: 'Meksikon peso',
    code: 'MXN',
  },
  MYR: {
    symbol: 'RM',
    name: 'Malesian ringgit',
    code: 'MYR',
  },
  MZN: {
    symbol: 'MTn',
    name: 'Mosambikin metical',
    code: 'MZN',
  },
  NAD: {
    symbol: 'N$',
    name: 'Namibian Dollari',
    code: 'NAD',
  },
  NGN: {
    symbol: '₦',
    name: 'Nigerian Naira',
    code: 'NGN',
  },
  NIO: {
    symbol: 'C$',
    name: 'Nicaraguan Córdoba',
    code: 'NIO',
  },
  NOK: {
    symbol: 'Nkr',
    name: 'Norjan kruunu',
    code: 'NOK',
  },
  NPR: {
    symbol: 'NPRs',
    name: 'Nepalin rupia',
    code: 'NPR',
  },
  NZD: {
    symbol: 'NZ$',
    name: 'Uuden-Seelannin dollari',
    code: 'NZD',
  },
  OMR: {
    symbol: 'OMR',
    name: 'Omanin rial',
    code: 'OMR',
  },
  PAB: {
    symbol: 'B/.',
    name: 'Panaman Balboa',
    code: 'PAB',
  },
  PEN: {
    symbol: 'S/.',
    name: 'Perun nuevo sol',
    code: 'PEN',
  },
  PHP: {
    symbol: '₱',
    name: 'Filippiinien peso',
    code: 'PHP',
  },
  PKR: {
    symbol: 'PKRs',
    name: 'Pakistanin rupia',
    code: 'PKR',
  },
  PLN: {
    symbol: 'zł',
    name: 'Puolan złoty',
    code: 'PLN',
  },
  PYG: {
    symbol: '₲',
    name: 'Paraguayn guaraní',
    code: 'PYG',
  },
  QAR: {
    symbol: 'QR',
    name: 'Qatarin rial',
    code: 'QAR',
  },
  RON: {
    symbol: 'RON',
    name: 'Romanian Leu',
    code: 'RON',
  },
  RSD: {
    symbol: 'din.',
    name: 'Serbian dinaari',
    code: 'RSD',
  },
  RUB: {
    symbol: 'RUB',
    name: 'Venäjän rupla',
    code: 'RUB',
  },
  RWF: {
    symbol: 'RWF',
    name: 'Ruandan frangi',
    code: 'RWF',
  },
  SAR: {
    symbol: 'SR',
    name: 'Saudi-Arabian rial',
    code: 'SAR',
  },
  SDG: {
    symbol: 'SDG',
    name: 'Sudanin punta',
    code: 'SDG',
  },
  SEK: {
    symbol: 'Skr',
    name: 'Ruotsin kruunu',
    code: 'SEK',
  },
  SGD: {
    symbol: 'S$',
    name: 'Singaporen dollari',
    code: 'SGD',
  },
  SOS: {
    symbol: 'Ssh',
    name: 'Somalian šillinki',
    code: 'SOS',
  },
  SYP: {
    symbol: 'SY£',
    name: 'Syyrian punta',
    code: 'SYP',
  },
  THB: {
    symbol: '฿',
    name: 'Thaimaan baht',
    code: 'THB',
  },
  TND: {
    symbol: 'DT',
    name: 'Tunisian dinaari',
    code: 'TND',
  },
  TOP: {
    symbol: 'T$',
    name: 'Tongan Paʻanga',
    code: 'TOP',
  },
  TRY: {
    symbol: 'TL',
    name: 'Turkin liira',
    code: 'TRY',
  },
  TTD: {
    symbol: 'TT$',
    name: 'Trinidad ja Tobagon dollari',
    code: 'TTD',
  },
  TWD: {
    symbol: 'NT$',
    name: 'Uusi Taiwanin dollari',
    code: 'TWD',
  },
  TZS: {
    symbol: 'TSh',
    name: 'Tansanian šillinki',
    code: 'TZS',
  },
  UAH: {
    symbol: '₴',
    name: 'Ukrainan hryvnia',
    code: 'UAH',
  },
  UGX: {
    symbol: 'USh',
    name: 'Ugandan šillinki',
    code: 'UGX',
  },
  UYU: {
    symbol: '$U',
    name: 'Uruguayn peso',
    code: 'UYU',
  },
  UZS: {
    symbol: 'UZS',
    name: 'Uzbekistanin som',
    code: 'UZS',
  },
  VEF: {
    symbol: 'Bs.F.',
    name: 'Venezuelan bolívar',
    code: 'VEF',
  },
  VND: {
    symbol: '₫',
    name: 'Vietnamin đồng',
    code: 'VND',
  },
  XAF: {
    symbol: 'FCFA',
    name: 'CFA-frangi',
    code: 'XAF',
  },
  XOF: {
    symbol: 'CFA',
    name: 'CFA-frangi',
    code: 'XOF',
  },
  YER: {
    symbol: 'YR',
    name: 'Jemenin rial',
    code: 'YER',
  },
  ZAR: {
    symbol: 'R',
    name: 'Etelä-Afrikan randi',
    code: 'ZAR',
  },
  ZMW: {
    symbol: 'ZK',
    name: 'Sambian kwacha',
    code: 'ZMW',
  },
};
